import React from 'react';
import CSVDemigrator from '../components/CSVDemigrator';

const CSVDemigratorPage = () => {
  return <CSVDemigrator />;
};

export default CSVDemigratorPage;
